/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const SAVED_CART_LIST_PROCESS_ID = 'saved-cart-list';
export const SAVED_CART_RESTORE_CART_PROCESS_ID = 'saved-cart-restore-cart';
export const SAVED_CART_SAVE_CART_PROCESS_ID = 'saved-cart-save-cart';
export const SAVED_CART_CLONE_CART_PROCESS_ID = 'saved-cart-clone-cart';
